'use client';

import dynamic from 'next/dynamic';

// Wrapper so layout.tsx (a Server Component) can dynamic-import FloatingChat with ssr:false.
// Saves ~150kB from initial bundle on every page; chat hydrates after page is interactive.
export const FloatingChat = dynamic(
  () => import('./FloatingChat').then(m => m.FloatingChat),
  { ssr: false }
);
